import { render } from "./plans.vue?vue&type=template&id=03051bb9&scoped=true"
import script from "./plans.vue?vue&type=script&lang=js"
export * from "./plans.vue?vue&type=script&lang=js"

import "./plans.vue?vue&type=style&index=0&id=03051bb9&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03051bb9"]])

export default __exports__